import CancelRenewal from '../../../ManageMembership/CancelRenewal/CancelRenewal';
import { formatTransactionDate } from '../../../../utils/dates';

import useScrollToTop from '../../../../utils/hooks/useScrollToTop';

import './ConfirmStep.scss';

const ConfirmStep = ({
  onHandleNext,
  membershipSubscriptionData,
  setMembershipSubscriptionData,
  setIsLoading,
  comments,
  reason,
  setError,
}) => {
  useScrollToTop();

  return (
    <div className="ConfirmStep">
      <div className="ConfirmStep__container">
        <div className="ConfirmStep__container--header">
          <div className="ConfirmStep__container--header-title">
            Are you sure?
          </div>
          <div className="ConfirmStep__container--header-description">
            {`Your membership will end on ${formatTransactionDate(membershipSubscriptionData.currentPeriodEnd)}, and you will lose access to all the membership perks.`}
          </div>
        </div>
        <div className="ConfirmStep__container--footer">
          <CancelRenewal
            membershipSubscriptionData={membershipSubscriptionData}
            setMembershipSubscriptionData={setMembershipSubscriptionData}
            onHandleNext={onHandleNext}
            setIsLoading={setIsLoading}
            comments={comments}
            reason={reason}
            setError={setError}
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmStep;
